// Collection thumbnails in the mega menu / nav drawer are now rendered
// server-side in Liquid (mega-menu-horizontal.liquid, navigation-panel.liquid),
// so the previous client-side /collections/{handle}.json fetch was removed.

const swagStockImages = {
  0: {
    src: "https://cdn.shopify.com/s/files/1/0570/9892/8313/files/out-of-stock-0-bars.png?v=1787956535",
    alt: "Out of stock"
  },
  1: {
    src: "https://cdn.shopify.com/s/files/1/0570/9892/8313/files/low-stock-1-bar.png?v=1787956535",
    alt: "Low stock"
  },
  2: {
    src: "https://cdn.shopify.com/s/files/1/0570/9892/8313/files/in-stock-2-bars.png?v=1787956534",
    alt: "In stock"
  },
  3: {
    src: "https://cdn.shopify.com/s/files/1/0570/9892/8313/files/in-stock-3-bars.png?v=1787956535",
    alt: "In stock"
  },
  4: {
    src: "https://cdn.shopify.com/s/files/1/0570/9892/8313/files/in-stock-4-bars.png?v=1787956534",
    alt: "In stock"
  }
};

function replaceSwagStockMessage() {
  document.querySelectorAll(".EasyStock-Text").forEach((element) => {
    const marker = element.textContent.match(/SWAG-STOCK-([0-4])/i);

    if (!marker) return;

    const level = marker[1];
    const imageInformation = swagStockImages[level];

    if (!imageInformation) return;

    element.innerHTML = `
      <img
        class="swag-stock-image"
        src="${imageInformation.src}"
        alt="${imageInformation.alt}"
        width="230"
        height="130"
      >
    `;
  });
}

function startSwagStockImages() {
  replaceSwagStockMessage();

  const observer = new MutationObserver(() => {
    replaceSwagStockMessage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startSwagStockImages);
} else {
  startSwagStockImages();
}

/* -------------------------------------------------------
   COMPATIBLE OPTIONS HEADING
------------------------------------------------------- */

function updateSwagCompatibleHeading() {
  document
    .querySelectorAll(".product-compatibility-form")
    .forEach(function (form) {
      var brandSelect = form.querySelector("#brand-select");
      var addons = form.querySelector('[class*="--addons"]');
      var heading = addons ? addons.querySelector("h2") : null;
      var brand = brandSelect ? brandSelect.value : "";

      if (!brand || !heading) return;

      var desiredText =
        "Compatible Options for Your " + brand + " Saw";

      if (heading.textContent.trim() !== desiredText) {
        heading.textContent = desiredText;
      }

      heading.classList.add("swag-compatible-options__title");
    });
}

function scheduleSwagCompatibleHeading() {
  window.setTimeout(updateSwagCompatibleHeading, 0);
  window.setTimeout(updateSwagCompatibleHeading, 150);
  window.setTimeout(updateSwagCompatibleHeading, 500);
}

document.addEventListener("change", function (event) {
  if (
    event.target.matches(
      ".product-compatibility-form #brand-select, " +
      ".product-compatibility-form #model-select"
    )
  ) {
    scheduleSwagCompatibleHeading();
  }
});

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    scheduleSwagCompatibleHeading
  );
} else {
  scheduleSwagCompatibleHeading();
}